module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-150.f4c83df8.svg";